// SEO Keywords and Meta Data for JaraNets Safety Solutions
export const SEO_CONFIG = {
  // Primary location-based keywords
  locations: [
    'Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Hyderabad', 'Pune', 'Kolkata', 
    'Ahmedabad', 'Jaipur', 'Surat', 'Lucknow', 'Kanpur', 'Nagpur', 'Indore',
    'Thane', 'Bhopal', 'Visakhapatnam', 'Pimpri-Chinchwad', 'Patna', 'Vadodara'
  ],
  
  // Service-specific keywords
  services: {
    invisibleGrill: [
      'invisible grill installation',
      'invisible grill for windows',
      'invisible grill for balconies',
      'invisible grill for apartments',
      'transparent safety grill',
      'clear view grill',
      'invisible window protection'
    ],
    safetyNets: [
      'safety nets installation',
      'construction safety nets',
      'industrial safety nets',
      'sports safety nets',
      'child safety nets',
      'car parking nets',
      'swimming pool safety nets'
    ],
    pigeonNets: [
      'pigeon nets installation',
      'bird protection nets',
      'anti-bird nets',
      'pigeon control nets',
      'bird deterrent nets'
    ],
    clothHangers: [
      'pull dry cloth hangers',
      'ceiling cloth hangers',
      'balcony cloth hangers',
      'outdoor cloth drying',
      'clothesline installation'
    ],
    specialtyNets: [
      'coconut nets',
      'construction nets',
      'shade nets',
      'agricultural nets',
      'protective nets'
    ]
  }
};

// Generate SEO meta data for each page
export const generateSEOMeta = (pageType: string, service?: string, location?: string) => {
  const baseKeywords = [
    'safety nets',
    'invisible grill',
    'pigeon nets',
    'construction safety',
    'industrial safety',
    'child safety nets',
    'car parking nets',
    'swimming pool nets',
    'cloth hangers',
    'safety solutions',
    'net installation',
    'safety equipment'
  ];

  const locationKeywords = location ? [
    `${location} safety nets`,
    `${location} invisible grill`,
    `${location} pigeon nets`,
    `safety nets in ${location}`,
    `invisible grill ${location}`,
    `pigeon nets ${location}`
  ] : [];

  const serviceKeywords = service ? [
    `${service} installation`,
    `${service} services`,
    `${service} ${location || 'India'}`,
    `professional ${service}`,
    `best ${service} company`
  ] : [];

  const allKeywords = [...baseKeywords, ...locationKeywords, ...serviceKeywords].join(', ');

  return {
    keywords: allKeywords,
    description: generateDescription(pageType, service, location),
    title: generateTitle(pageType, service, location)
  };
};

const generateTitle = (pageType: string, service?: string, location?: string) => {
  const baseTitle = 'JaraNets Safety Solutions';
  
  switch (pageType) {
    case 'home':
      return `${baseTitle} - Professional Safety Nets & Invisible Grill Installation Services`;
    case 'service':
      return `${service} Installation Services - ${baseTitle}`;
    case 'about':
      return `About ${baseTitle} - Leading Safety Solutions Provider`;
    case 'contact':
      return `Contact ${baseTitle} - Get Free Quote for Safety Solutions`;
    default:
      return `${baseTitle} - Professional Safety Solutions`;
  }
};

const generateDescription = (pageType: string, service?: string, location?: string) => {
  const baseDesc = 'Professional safety nets, invisible grill, and pigeon nets installation services.';
  
  switch (pageType) {
    case 'home':
      return `${baseDesc} Expert installation of construction safety nets, industrial safety nets, child safety nets, and invisible grill systems across India. Free quotes and professional service.`;
    case 'service':
      return `Professional ${service} installation services by JaraNets. Expert installation, quality materials, and reliable service. Get free quote today.`;
    case 'about':
      return `Learn about JaraNets Safety Solutions - India's leading provider of safety nets, invisible grill, and pigeon nets installation services.`;
    case 'contact':
      return `Contact JaraNets for professional safety solutions. Free quotes, expert installation, and reliable service. Call now for consultation.`;
    default:
      return baseDesc;
  }
};

// Structured data for local business
export const generateStructuredData = () => {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "JaraNets Safety Solutions",
    "description": "Professional safety nets, invisible grill, and pigeon nets installation services",
    "url": "https://jaranets.com",
    "telephone": "+91-8466055207",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IN",
      "addressRegion": "India"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "19.0760",
      "longitude": "72.8777"
    },
    "openingHours": "Mo-Fr 09:00-18:00",
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "19.0760",
        "longitude": "72.8777"
      },
      "geoRadius": "50000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Safety Solutions",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Safety Nets Installation",
            "description": "Professional safety nets for construction, industrial, and sports applications"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Invisible Grill Installation",
            "description": "Transparent safety grill systems for windows, balconies, and apartments"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pigeon Nets Installation",
            "description": "Bird protection and pigeon control net systems"
          }
        }
      ]
    }
  };
};
